// TokenDetailModal.tsx
import React from 'react';
import { Box } from '@mui/material';
import styles from './TokenDetailModal.module.sass';
import { ConstructionBadge } from 'utils/ConstructionBadge';

const TokenDetailModal = ({ token, onClose, isOpen }) => {
  if (!isOpen || !token) return null;
  
  const formatNumber = (num) => {
    if (!num) return '0';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num);
  };
  
  return (
    <Box className={styles.modalOverlay} onClick={onClose}>
      <Box className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <Box className={styles.modalHeader}>
          <Box className={styles.modalTokenInfo}>
            <img src={token.token_logo} alt={token.token_name} />
            <Box>
              <Box component="span" className={styles.modalTokenName}>{token.token_name}</Box>
              <Box component="span" className={styles.modalTokenSymbol}>{token.token_symbol}</Box>
            </Box>
          </Box>
          <button className={styles.modalClose} onClick={onClose}>×</button>
        </Box>
        
        <Box className={styles.modalStats}>
          <Box className={styles.modalStat}>
            <Box component="span">Market Cap</Box>
            <Box component="span">{formatNumber(token.market_cap_usd)}</Box>
          </Box>
          <Box className={styles.modalStat}>
            <Box component="span">Price</Box>
            <Box component="span">${Number(token.price_usd).toFixed(4)}</Box>
          </Box>
          <Box className={styles.modalStat}>
            <Box component="span">24h Change</Box>
            <Box 
              component="span" 
              className={!token.price_24h_percent_change?.includes('-') ? styles.positive : styles.negative}
            >
              {Number(token.price_24h_percent_change).toFixed(2)}%
            </Box>
          </Box>
          <Box className={styles.modalStat}>
            <Box component="span">7d Change</Box>
            <Box 
              component="span" 
              className={!token.price_7d_percent_change?.includes('-') ? styles.positive : styles.negative}
            >
              {Number(token.price_7d_percent_change).toFixed(2)}%
            </Box>
          </Box>
        </Box>
        <Box className={styles.modalContract}>
          <Box component="span">Contract Address</Box>
          <Box component="span">{token.contract_address}</Box>
        </Box>
        
        <Box className={styles.modalActions}>
          <ConstructionBadge />
          <a 
            href={`/nebula-search?contract=${encodeURIComponent(token.contract_address + ' insights')}`} 
            className={styles.modalButton}
            onClick={onClose}
          >
            Search Blockchain
          </a>
          <a 
            href={`/nebula-search?contract=${encodeURIComponent(token.contract_address + ' rug analysis')}`} 
            className={styles.modalButton}
            onClick={onClose}
          >
            Rug Analysis
          </a>
        </Box>
      </Box>
    </Box>
  );
};

export default TokenDetailModal;